import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  InputAdornment,
  Stack,
  Tab,
  Tabs,
  TextField
} from "@mui/material";
import { useTranslation } from "react-i18next";

export function UsersTableHeader({
  tabValue,
  setTabValue,
  searchQuery,
  setSearchQuery
}) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        color: "white",
        backgroundColor: "primary.main",
        py: 1,
        px: 2,
        borderRadius: "5px"
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Tabs
          value={tabValue}
          onChange={(event, value) => setTabValue(value)}
          aria-label="basic tabs example"
          indicatorColor=""
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            label={t("systemAdmins.systemAdmins.SystemAdmins")}
            sx={{
              color: "white",
              "&.Mui-selected": {
                borderRadius: "5px",
                background: "white",
                color: "primary.main"
              }
            }}
          />
          <Tab
            label={t("systemAdmins.systemAdmins.Logs")}
            sx={{
              color: "white",
              "&.Mui-selected": {
                borderRadius: "5px",
                background: "white",
                color: "primary.main"
              }
            }}
          />
          <Tab
            label={t("systemAdmins.systemAdmins.RoleManagement")}
            sx={{
              color: "white",
              "&.Mui-selected": {
                borderRadius: "5px",
                background: "white",
                color: "primary.main"
              }
            }}
          />
        </Tabs>
        {tabValue === 1 && (
          <Stack direction="row" spacing={2} alignItems="center">
            <TextField
              variant="outlined"
              size="small"
              placeholder={t("denominations.denominations.search")}
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon color="primary" />
                  </InputAdornment>
                ),
                sx: {
                  px: 1,
                  borderRadius: "50px",
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none"
                  },
                  "&.Mui-focused": {
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    }
                  }
                }
              }}
            />
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
